// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1ly9n","obliqueLineWrap":"membershipbadge_obliqueLineWrap__iliqq","obliqueLine":"membershipbadge_obliqueLine__M__Sy"};